import CrudController from "./crud_controller";

export default class extends CrudController {
  connect() {
    this.siteNum = this.data.get("siteNum");
    this.devNum = this.data.get("devNum");
    this.loadList();
  }

  loadList() {
    this.clearMessage();

    this.fetchForTarget(window.App.prefixedUrl(`/sites/${this.siteNum}/devices/${this.devNum}/phones`), this.listTarget)
    .then(() =>
    {
      App.$iconify.scanDOM();
       if(window.App.EDIT_MODE) this.showNewLink();
    });
  }

  handleEdit(event)
  {
    if (event.detail[0].success)
    {
      
    }
    else
    {
      
    }
  }

  new(event)
  {
    this.clearMessage();
    this.fetchForTarget(window.App.prefixedUrl(`/sites/${this.siteNum}/devices/${this.devNum}/phones/new`), this.listTarget)
      .then(() =>
      {
        this.hideNewLink();
      });
  }

  edit(event)
  {
    let div = document.createElement("div");
      div.classList.add("circle-loader");

    let button = event.target.closest("button");

    button.replaceWith(div);

    this.clearMessage();
    let seqNum = event.currentTarget.dataset.seqNum;
    this.fetchForTarget(window.App.prefixedUrl(`/sites/${this.siteNum}/devices/${this.devNum}/phones/${seqNum}/edit`), this.listTarget)
      .then(() =>
      {
        this.hideNewLink();
        div.replaceWith(button);

      });
  }
}